import type { DataTableColumn } from '@/components/custom/erp/data-table-v2';
// import { DateRangePresets } from '@/components/custom/erp';

export const exportAccountColumns = (
  handleOpenViewForm: MuaHangRecord,
  handleOpenEditForm: MuaHangRecord,
  selectedIds: MuaHangRecord,
  handleCheckboxChange: (id: string) => void
): DataTableColumn[] => [
  {
    field: 'checkbox',
    headerName: '',
    width: 50,
    resizable: false
  },
  { field: 'supplierCode', headerName: 'Mã NCC', width: 120 },
  { field: 'supplierName', headerName: 'Tên nhà cung cấp', width: 250 },
  { field: 'openingDebit', headerName: 'Dư nợ đầu', width: 120 },
  { field: 'openingCredit', headerName: 'Dư có đầu', width: 120 },
  { field: 'debitTransactions', headerName: 'PS nợ', width: 120 },
  { field: 'creditTransactions', headerName: 'PS có', width: 120 },
  { field: 'closingDebit', headerName: 'Dư nợ cuối', width: 120 },
  { field: 'closingCredit', headerName: 'Dư có cuối', width: 120 }
];

export const exportPrintColColums: DataTableColumn[] = [
  { field: 'col', headerName: 'Cột', width: 150 },
  { field: 'colName', headerName: 'Tên cột', width: 150 },
  { field: 'colNameEng', headerName: 'Tên tiếng anh', width: 150 },
  { field: 'colWidth', headerName: 'Độ rộng', width: 150 },
  { field: 'colType', headerName: 'Định dạng', width: 150 },
  { field: 'colAlign', headerName: 'Căn chỉnh', width: 150 },
  { field: 'colBold', headerName: 'In đậm', width: 150 },
  { field: 'colItalic', headerName: 'In nghiêng', width: 150 },
  { field: 'colSum', headerName: 'Tổng', width: 150 }
];

export const TKCoSearchColBasicInfo: DataTableColumn[] = [
  { field: 'code', headerName: 'Mã tài khoản', flex: 1 },
  { field: 'account_name', headerName: 'Tên tài khoản', flex: 2 },
  { field: 'parent_account', headerName: 'Tài khoản mẹ ', flex: 1 },
  { field: 'ledger_account', headerName: 'Tài khoản sổ cái', flex: 1 },
  { field: 'is_group', headerName: 'Tài khoản chi tiết', flex: 1 },
  { field: 'account_level', headerName: 'Bậc tài khoản', flex: 1 }
];

export const MaNCCSearchCol: DataTableColumn[] = [
  { field: 'code', headerName: 'Mã đối tượng', flex: 1 },
  { field: 'supplier_name', headerName: 'Tên đối tượng', flex: 2 },
  { field: 'receivable', headerName: 'Công nợ p/thu', flex: 1 },
  { field: 'payable', headerName: 'Công nợ p/trả', flex: 1 },
  { field: 'tax_code', headerName: 'Mã số thuế', flex: 1 },
  { field: 'email', headerName: 'Email', flex: 1 },
  { field: 'phone', headerName: 'Số điện thoại', flex: 1 }
];

export const KhuVucSearchCol: DataTableColumn[] = [
  { field: 'code', headerName: 'Mã khu vực', flex: 1 },
  { field: 'name', headerName: 'Tên khu vực', flex: 2 }
];

export const MaNhomSearchCol: DataTableColumn[] = [
  { field: 'code', headerName: 'Mã nhóm', flex: 1 },
  { field: 'name', headerName: 'Tên nhóm', flex: 2 }
];
